"use client";
import { cva as e } from "class-variance-authority";
const n = e("size-4 inline-block leading-[1em] shrink-0 text-current align-middle");
export {
  n as icon
};
